import { createSelector } from 'reselect';
import { statsLeadersNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Round.
 */
export const roundSelector = createSelector(
    statsLeadersNavSelector,
    (state) => state.rounds,
    (nav, rounds) => {
        try {
            return rounds[`season_${nav.season.id}`][`round_${nav.round.id}`];
        } catch (err) {
            return null;
        }
    }
);
